import { Link } from 'react-router-dom';

const TermsPage = () => {
  return (
    <div className="min-h-screen py-12 bg-[#FAFAFA]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-8">
          <Link to="/" className="text-[#0A2342] hover:text-[#FF6B35] text-sm">
            ← Back to Home
          </Link>
        </div>
        
        <h1 className="text-4xl font-heading font-bold text-[#0A2342] mb-8">
          Terms and Conditions
        </h1>
        
        <div className="bg-white rounded-lg p-8 shadow-sm space-y-8">
          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">1. Introduction</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms and Conditions govern the use of the website www.justdive.co.za ("the Website") and all products and services provided by Just Dive ("Just Dive", "we", "us", "our"). By accessing, browsing, registering, or purchasing from this Website, you agree to be bound by these Terms and Conditions. If you do not agree, you must not use the Website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">2. Business Information</h2>
            <p className="text-gray-700 leading-relaxed">
              Just Dive operates in the Republic of South Africa and conducts business in accordance with South African law. All transactions concluded through the Website are deemed to take place in South Africa.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">3. Definitions</h2>
            <ul className="text-gray-700 leading-relaxed space-y-2 list-disc list-inside">
              <li><strong>Customer</strong> means any person who accesses or uses the Website.</li>
              <li><strong>Member</strong> means a registered user enrolled in the Just Dive Club or Just Dive Pro.</li>
              <li><strong>Products</strong> means dive equipment and related goods sold via the Website.</li>
              <li><strong>Services</strong> means training, trips, memberships, and related offerings.</li>
              <li><strong>CPA</strong> means the Consumer Protection Act 68 of 2008.</li>
              <li><strong>ECTA</strong> means the Electronic Communications and Transactions Act 25 of 2002.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">4. Use of the Website</h2>
            <p className="text-gray-700 leading-relaxed">
              The Website may only be used for lawful purposes. You may not misrepresent your identity or membership status, interfere with the operation or security of the Website, or use the Website for fraudulent or unlawful activities. Just Dive reserves the right to restrict or terminate access where misuse is identified.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">5. Products and Pricing</h2>
            <p className="text-gray-700 leading-relaxed">
              All products are subject to availability. Prices are displayed in South African Rand (ZAR) and include VAT unless stated otherwise. Just Dive reserves the right to amend prices, descriptions, or availability without prior notice. Member pricing is available only to logged-in users with an active membership.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">6. Memberships</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Just Dive Club</strong> is an annual membership providing access to preferential pricing, offers, and benefits. Membership fees are payable in advance and are non-refundable except where required by law.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Just Dive Pro</strong> is a subscription-based membership offered on a minimum twelve-month commitment. Membership fees are payable in advance and are non-refundable except where required by law. Failure to make payment may result in suspension or termination of benefits. Just Dive reserves the right to suspend or terminate membership where benefits are misused or false information is provided.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">7. Training Services (ISO-Aligned)</h2>
            <p className="text-gray-700 leading-relaxed">
              All training offered by Just Dive is conducted in accordance with internationally recognised ISO-based scuba diving training standards. Certification is awarded only upon successful completion of all required theory, confined water, and open water components. Students must meet medical fitness and performance requirements. Payment alone does not guarantee certification. Training may be paused or terminated for safety reasons.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">8. Dive Trips</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Dive trips are subject to minimum participant numbers, environmental conditions, and third-party operator availability. Trips are confirmed only once minimum numbers are reached. Dates and itineraries may change due to operational or safety requirements. Just Dive is not liable for delays or cancellations caused by force majeure events.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Trip prices do not include transport, food, or drinks unless expressly stated.</strong> These are for the customer's own account.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">9. Returns and Refunds</h2>
            <p className="text-gray-700 leading-relaxed">
              Customers may cancel online purchases within seven days of receipt in accordance with ECTA, provided goods are unused and in original packaging. Defective goods may be returned within six months as provided by the CPA. Membership fees are non-refundable once activated, except where required by law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">10. Delivery and Shipping</h2>
            <p className="text-gray-700 leading-relaxed">
              Product prices do not include delivery or shipping costs unless expressly stated. Delivery charges are calculated per transaction and displayed at checkout. Risk of loss passes to the customer upon delivery.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">11. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed">
              All content on the Website is the property of Just Dive or its licensors and may not be reproduced without permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">12. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              Just Dive shall not be liable for indirect, consequential, or economic loss. Nothing in these Terms limits rights granted under the Consumer Protection Act.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">13. Privacy and Data Protection</h2>
            <p className="text-gray-700 leading-relaxed">
              Personal information is processed in accordance with South African data protection laws. A separate Privacy Policy governs data handling.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">14. Electronic Communications</h2>
            <p className="text-gray-700 leading-relaxed">
              By using the Website, you consent to receiving electronic communications relating to your account and services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">15. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms and Conditions are governed by the laws of the Republic of South Africa.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">16. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              Just Dive reserves the right to amend these Terms at any time. Continued use constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-semibold text-[#0A2342] mb-4">17. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              Website: www.justdive.co.za
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
